import React, { useEffect, useState, useRef } from 'react';
import { DivFormGroup, DivInput, FixedSelect, FixedSelectSpan, LabelInput } from './styles';

function SelectFixoTotvs({ options, styleAux, selectedOptionValue, onChange, isLabel, label, value, multiple, disabled }) {
  const [selectedOption, setSelectedOption] = useState();
  const selectRef = useRef(null);

  const handleSelectOption = (selectedOption) => {
    setSelectedOption(selectedOption);
    onChange(selectedOption);
  };

  useEffect(() => {
    if (selectedOptionValue && typeof selectedOptionValue === 'string') {
      const option = options.find((option) => option.value === selectedOptionValue);
      handleSelectOption(option);
    }
  }, [selectedOptionValue]);

  return (
    <>
      {isLabel !== undefined && (
        <DivFormGroup >
          <LabelInput id="inputGroup-sizing-sm" className="input-group-text">{label}</LabelInput>
          <DivInput>
            {value ? (
              <FixedSelect
                ref={selectRef}
                options={options}
                isMulti={multiple}
                isSearchable
                isDisabled={disabled}
                onChange={(selectOption) => { handleSelectOption(selectOption); }}
                getOptionValue={(option) => option.value}
                getOptionLabel={(option) => option.text}
                value={value}
                style={styleAux}
                placeholder="Selecione..."
                menuPortalTarget={document.body}
              />
            ) : (
              <FixedSelect
                ref={selectRef}
                options={options}
                isMulti={multiple}
                isSearchable
                isDisabled={disabled}
                onChange={(selectOption) => { handleSelectOption(selectOption); }}
                getOptionValue={(option) => option.value}
                getOptionLabel={(option) => option.text}
                value={selectedOptionValue}
                style={styleAux}
                placeholder="Selecione..."
                menuPortalTarget={document.body}
              />
            )}
          </DivInput>
        </DivFormGroup>
      )}

      {!isLabel && (
        <FixedSelectSpan
          ref={selectRef}
          options={options}
          isMulti={multiple}
          isSearchable
          onChange={(selectOption) => { handleSelectOption(selectOption); }}
          getOptionValue={(option) => option.value}
          getOptionLabel={(option) => option.text}
          value={selectedOption}
          style={styleAux}
          menuPortalTarget={document.body}
        />
      )}
    </>
  );
};

export default SelectFixoTotvs;
